/** Admin's not-found page fills the viewport below its 64px top bar, with a 16px margin. */
export const ADMIN_NOT_FOUND_SX = {
  height: "calc(100vh - 64px)",
  p: 2,
} as const;
